import Icon from '../components/Icon.vue'

Icon.register({
  'volume-down': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M215 72c15-15 41-4.5 41 17v336c0 21.4-25.9 32-41 17l-89-89h-102.1c-13.3 0-24-10.8-24-24v-144c0-13.3 10.7-24 24-24h102.1zM338.2 180.1c28.2 15.5 45.8 45 45.8 76.9s-17.5 61.3-45.8 76.9c-11.6 6.3-26.2 2.2-32.6-9.5-6.4-11.6-2.2-26.2 9.5-32.6 12.9-7.1 20.9-20.4 20.9-34.8s-8-27.7-20.9-34.8c-11.6-6.4-15.8-21-9.5-32.6 6.4-11.6 21-15.8 32.6-9.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-down.js
// module id = 2095
// module chunks = 0